import classNames from 'classnames';
import { focusNumber } from '@/utils/dom';
import { ArrowLeftSvg, ArrowRightSvg } from '../../Svg/index';
import style from './index.module.less';

interface IArrow{
  limits: Array<{min: number; max: number;}>;
  currentFocus: number;
  pageDataIndex: number;
  setPanelHandle: (value: number) => void;
  setFocusIndexHandle: (value: number) => void;
}

export default function Arrow(props: IArrow) {
  const {limits, setPanelHandle, setFocusIndexHandle, currentFocus, pageDataIndex} = props;
  const left = limits[0] && limits[0].min;
  const right = limits[0] && limits[limits.length - 1].max;
  // console.log('left', left, right, currentFocus);
  const rightClick = () => {
    let nextFocus = currentFocus + 1;
    const fIndex = limits.findIndex((item: {min :number; max: number;}) => {
      const {min, max} = item;
      return nextFocus >= min && nextFocus <= max;
    });
    if (fIndex !== -1 && fIndex !== pageDataIndex) {
      setPanelHandle(fIndex);
    }
    if (nextFocus > right) {
      nextFocus = right;
      return;
    }
    const min = limits[fIndex].min;
    setFocusIndexHandle(nextFocus);
    focusNumber(nextFocus, min);
  };

  const leftClick = () => {
    let nextFocus = currentFocus - 1;
    const fIndex = limits.findIndex((item: {min :number; max: number;}) => {
      const {min, max} = item;
      return nextFocus >= min && nextFocus <= max;
    });
    if (fIndex !== -1 && fIndex !== pageDataIndex) {
      setPanelHandle(fIndex);
    }
    const min = limits[fIndex].min;
    if (nextFocus < left) {
      nextFocus = left;
      return;
    }
    console.log('setFocusIndex', nextFocus);
    setFocusIndexHandle(nextFocus);
    focusNumber(nextFocus, min);
  };
  return (
    <div className={style.arrows}>
      <div className={classNames(style.left, style.box, currentFocus === left ? style.disabled : '')} onClick={leftClick}>{ArrowLeftSvg}</div>
      <div className={classNames(style.right, style.box, currentFocus === right ? style.disabled : '')} onClick={rightClick}>{ArrowRightSvg}</div>
    </div>
  );
}